import React from "react";
import ServerErrorPage from "./ServerErrorPage";

export default class PublicErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("SugaLumps public route error", error, info);
    }
  }

  reset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <ServerErrorPage resetError={this.reset} />;
    }
    return this.props.children;
  }
}
